import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import * as _ from 'lodash';
import { CustomerService } from 'src/app/services/customer/customer.service';
@Component({
  selector: 'app-confirm-update',
  templateUrl: './confirm-update.component.html',
  styleUrls: ['./confirm-update.component.scss']
})
export class ConfirmUpdateCarrierComponent implements OnInit {

  public loading: boolean = false;
  private sub: any;
  public carrierUserID: string;
  public affiliatedCarrier: string;
  public carrier;
  public sysconNumber: any;
  public factoringCompany;
  public facCompId;

  constructor(public carrierService: CarrierService,
    private flashMessageService: FlashMessageService,
    private customerService: CustomerService,
    private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    if (!this.carrierService.updatedCarrierUser.name) {
      this.router.navigate(['../../'], { relativeTo: this.route });
    }
    this.sub = this.route.queryParams.subscribe(params => {
      this.carrierUserID = params['ID'];
      this.affiliatedCarrier = params['affiliatedCarrier'];
    });
    if (this.carrierService.isFactoringCompany) {
      this.getFactoringCompany();
    } else {
      this.getCarrier();
    }
  }

  getCarrier() {
    this.carrierService.getCarrierDetail(this.carrierService.updatedCarrierUser.organization.organizationCode).then(carrier => {
      this.carrier = carrier;
      this.carrier.xrefIds.forEach(xref => {
        if (xref.systemName === 'TPS') {
          this.sysconNumber = xref.id;
        }
      })
    });
  }

  getFactoringCompany() {
    this.carrierService.getFactoringCompanyDetail(this.carrierService.updatedCarrierUser.organization.organizationCode).then(factoringCompany => {
      this.factoringCompany = factoringCompany;
    }).catch(error => {
      this.flashMessageService.updateMessage(`Failed to get the factoring company details for: ${this.carrierUserID}`, 5000, "danger");
    });
  }

  public getVendorLocations() {
    return _.has(this.carrierService.updatedCarrierUser, "extended.locations") ? _.get(this.carrierService.updatedCarrierUser, "extended.locations") : [];
  }

  async confirm() {
    this.loading = true;
    if (!this.carrierService.isFactoringCompany && this.carrierService.shouldUpdateCarrierUnit()) {
      await this.customerService.updateCarriersModeAndUnit(this.carrierService.updatedCarrierUser.organization.organizationCode, this.carrierService.carrierUnit.transportMode, this.carrierService.carrierUnit.businessUnit);
    }
    this.carrierService.updateCarrierAffiliatedUser(this.carrierUserID, this.affiliatedCarrier)
      .then(() => {
        this.carrierService.resetCarrierUser();
        this.carrierService.isFactoringCompany = false;
        this.loading = false;
        this.flashMessageService.updateMessage("Successfully updated user", 3000, "success");
        this.router.navigate(['../../users'], { relativeTo: this.route });
      }).catch((error) => {
        this.loading = false;
      });
  }
}
